const defaultDevRegion = 'SG';

export function getRegion(hostname) {
  const isLocalhost = hostname.includes('localhost');
  if (hostname.includes('systems')) return 'VN';
  return isLocalhost ? defaultDevRegion : hostname.substr(-2).toUpperCase();
}

export function getCurRegion() {
  return getRegion(window.location.hostname);
}

export function getEnv(hostname = '') {
  const [projectName, env] = hostname.split('.');
  if (projectName !== 'spx') return 'dev';
  if (['test', 'uat', 'staging'].includes(env)) return env;
  if (env === 'shopee') return 'live';
  return 'dev';
}

export const getCurEnv = () => getEnv(window.location.hostname);

export const getCookie = (name) => {
  if (!name || !document.cookie) return null;
  const result = document.cookie.match(
    new RegExp(`(^| )${name}=([^;]*)(;|$)`, 'g'),
  );
  if (!!result && result.length > 0) {
    const keyValue = unescape(result[0]);
    const value = keyValue
      .substring(keyValue.indexOf('=') + 1, keyValue.length)
      .replace(/;$/, '');
    return value;
  }
  return null;
};

export function checkIsShopeeApp() {
  try {
    const ua = window.navigator.userAgent.toLowerCase();
    const reg = /shopee/gi;
    return reg.test(ua);
  } catch (error) {
    console.log('check browser ua error', error);
    return false;
  }
}

export function getQueryString(name) {
  const reg = new RegExp(`(^|&)${name}=([^&]*)(&|$)`, 'i');
  const r = window.location.search.substr(1).match(reg);
  if (r != null) {
    return decodeURIComponent(r[2]);
  }
  return null;
}
